import React from 'react'

import {AppBar, Container, Tab, Tabs} from '@material-ui/core'
import Box from "@material-ui/core/Box";

import Page from 'components/Page/Page'

import Machines from '../SettingsPage/Machines.js'

// Staff (non-manager) page. Add more tabs here for things staff need to view.
const OperationsPage = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  return (
    <Page title="Operations">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} variant="scrollable">
            <Tab label="Devices"/>
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <Machines readOnly/>
        </TabPanel>

      </Container>
    </Page>
  )
}

export default OperationsPage
